
// Copyright (c) 2021 Comsearch, Inc., All rights reserved

const makeSiteSearchFieldsForPathSearch = (data, search) => {
  const site1CallSign = data['site1-callSign']
  const site2CallSign = data['site2-callSign']
  const site1SiteName = data['site1-siteName']
  const site2SiteName = data['site2-siteName']

  if (site1CallSign || site2CallSign) {
    const callSign = []

    if (site1CallSign) {
      callSign.push(site1CallSign)
    } else if (site1SiteName && site2CallSign) {
      callSign.push('%')
    }

    if (site2CallSign) {
      callSign.push(site2CallSign)
    }

    if (callSign.length) {
      search.push({
        field: 'callSign',
        value: callSign.join(','),
        operator: 'LIKE',
      })
    }
  }

  if (site1SiteName || site2SiteName) {
    const siteName = []

    if (site1SiteName) {
      siteName.push(site1SiteName)
    } else if (site1CallSign && site2SiteName) {
      siteName.push('%')
    }

    if (site2SiteName) {
      siteName.push(site2SiteName)
    }

    if (siteName.length) {
      search.push({
        field: 'siteName',
        value: siteName.join(','),
        operator: 'LIKE',
      })
    }
  }
}

export default makeSiteSearchFieldsForPathSearch
